import React from 'react';

const FormFieldset = ({ children, className, legend }) => {
  // reusable form fieldset
  return (
    <fieldset className={`sb-form-item ` + (className || '')}>
      {legend && <legend>{legend}</legend>}
      <div className="sb-form-item-inner">
        <div className="sb-form-item-elements">{children}</div>
      </div>
    </fieldset>
  );
};

export default FormFieldset;
